const strings = {
  auxiliarySource: {
    title: 'Interação com a Fonte Auxiliar',
    newInteration: 'Nova Interação',
  },
}

export default strings
